import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useMatch, useNavigate } from 'react-router-dom';
import { bridge, isInShell } from './shell';
import { useAccounts } from '../accounts/AccountsContext';
import { usePrograms } from '../loyalty/ProgramsContext';

export function ShellNavigation({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentAccount } = useAccounts();
  const { programs } = usePrograms();
  const matchProgramRoute = useMatch('/accounts/:accountId/programs/:id/*');
  const [shellNavigation, setShellNavigation] = useState<string>();

  const title = useMemo(() => {
    if (matchProgramRoute) {
      const program = programs.find(p => p.id === matchProgramRoute.params.id);
      return program?.name;
    }
  }, [matchProgramRoute, programs]);

  useEffect(() => {
    bridge.handleTell('navigation', ({ path }) => {
      setShellNavigation(path);
    });
  }, []);

  useEffect(() => {
    if (shellNavigation) {
      const path = `${location.pathname}${location.search}`;
      if (shellNavigation !== path && currentAccount) {
        navigate(shellNavigation);
      } else {
        bridge.tell('tellLocation', { path, title });
      }
    }
  }, [shellNavigation]);

  useEffect(() => {
    if (isInShell() && currentAccount) {
      if (shellNavigation && matchProgramRoute && !title) {
        return;
      }
      const path = `${location.pathname}${location.search}`;
      if (!shellNavigation || shellNavigation === path) {
        bridge.tell('tellLocation', {
          path,
          title,
        });
      } else {
        // Navigation within iframe. Shell will send a message for confirmation
        // so shellNavigation should be updated first
        setShellNavigation(path);
      }
    }
  }, [location.pathname]);

  return <>{children}</>;
}
